export const waitForHtmlElements = async (
  containerId: string,
  selector: string
): Promise<NodeListOf<HTMLDivElement>> => {
  return await new Promise((resolve) => {
    const checkElements = () => {
      const elements = document.querySelector(`#${containerId}`)?.querySelectorAll<HTMLDivElement>(selector);
      if (elements && elements.length > 0) {
        resolve(elements);
      } else {
        requestAnimationFrame(checkElements);
      }
    };
    checkElements();
  });
};
